"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullOwnerDetails = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactHookForm = require("react-hook-form");
var _dayjs = _interopRequireDefault(require("dayjs"));
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _helpers = require("@PetSureAustralia/petsure-react-ui-library/distLib/helpers");
var _widgets = require("@PetSureAustralia/petsure-react-ui-library/distLib/widgets");
var _QuoteHeading = require("../../Layout/QuoteHeading");
var _useLocalSearch = require("../../../hooks/form/useLocalSearch");
var _useMatchBreakpoint2 = require("../../../hooks/useMatchBreakpoint");
var _useCustomContainerType = require("../../../hooks/useCustomContainerType");
var _brandContext = require("../../../contextProviders/brandContext");
var _PreloadWrapper = require("../../PreloadWrapper/PreloadWrapper");
var _form = require("../../../helpers/form");
var _AddressDetails = require("./AddressDetails/AddressDetails");
var _selectors = require("../../../store/form/selectors");
var _navigationContext = require("../../../contextProviders/navigationContext");
var _emailQuotePanelContextProvider = require("../../../contextProviders/emailQuotePanelContextProvider");
var _steps = require("../../../constants/app/steps");
var _constants = require("../../../constants/constants");
var _breakpoints = require("../../../constants/app/breakpoints");
var _environment = require("../../../helpers/environment");
var _excluded = ["validation"],
  _excluded2 = ["authorisedPersonPanelToggleRadios"],
  _excluded3 = ["validation"],
  _excluded4 = ["regularVetPanelToggleRadios"];
/* eslint-disable react/prop-types,camelcase */
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var FullOwnerDetails = exports.FullOwnerDetails = function FullOwnerDetails(_ref) {
  var _StepDefinitions$find, _actionButtonsBar$sec, _basicOwnerDetails$ow, _owner$authorisedMemb, _owner$authorisedMemb2, _manualAddressEntryPa, _formContext$getValue, _actionButtonsBar$pri, _actionButtonsBar$sec2;
  var isDataPending = _ref.isDataPending,
    _ref$onFormSubmit = _ref.onFormSubmit,
    onFormSubmit = _ref$onFormSubmit === void 0 ? function () {} : _ref$onFormSubmit;
  var _useContext = (0, _react.useContext)(_navigationContext.NavigationContext),
    navigationController = _useContext.navigationController;
  var _useContext2 = (0, _react.useContext)(_emailQuotePanelContextProvider.EmailQuoteContext),
    openEmailPanel = _useContext2.openEmailPanel;
  var _useContext3 = (0, _react.useContext)(_brandContext.BrandContext),
    _useContext3$activeBr = _useContext3.activeBrandContext,
    _useContext3$activeBr2 = _useContext3$activeBr.brand,
    brandKey = _useContext3$activeBr2.key,
    contactStatementLogo = _useContext3$activeBr2.contactStatementLogo,
    glm = _useContext3$activeBr2.glm,
    _useContext3$activeBr3 = _useContext3$activeBr.steps,
    basicOwnerDetails = _useContext3$activeBr3.basicOwnerDetails,
    _useContext3$activeBr4 = _useContext3$activeBr3.fullOwnerDetails,
    tncDisclaimer = _useContext3$activeBr4.tncDisclaimer,
    ownerTitleInput = _useContext3$activeBr4.ownerTitleInput,
    ownerBirthdateInput = _useContext3$activeBr4.ownerBirthdateInput,
    ownerEmailInput = _useContext3$activeBr4.ownerEmailInput,
    ownerFirstNameInput = _useContext3$activeBr4.ownerFirstNameInput,
    ownerLastNameInput = _useContext3$activeBr4.ownerLastNameInput,
    ownerMobileInput = _useContext3$activeBr4.ownerMobileInput,
    ownerAddressAutoCompleteInput = _useContext3$activeBr4.ownerAddressAutoCompleteInput,
    ownerEmailCommsRadios = _useContext3$activeBr4.ownerEmailCommsRadios,
    ownerMarketingFeedChannel = _useContext3$activeBr4.ownerMarketingFeedChannel,
    ownerVelocityMembershipNumber = _useContext3$activeBr4.ownerVelocityMembershipNumber,
    ownerMemberNumberInput = _useContext3$activeBr4.ownerMemberNumberInput,
    showCustomerSource = _useContext3$activeBr4.showCustomerSource,
    showMandatoryText = _useContext3$activeBr4.showMandatoryText,
    mandatoryText = _useContext3$activeBr4.mandatoryText,
    StepDefinitions = _useContext3$activeBr3.StepDefinitions,
    _useContext3$activeBr5 = _useContext3$activeBr.widgets,
    authorisedPersonDisplaySettings = _useContext3$activeBr5.authorisedPersonDisplaySettings,
    regularVetDisplaySettings = _useContext3$activeBr5.regularVetDisplaySettings,
    privacyCollectionNotice = _useContext3$activeBr.privacyCollectionNotice,
    manualAddressEntryPanel = _useContext3$activeBr.panelConfigurations.manualAddressEntryPanel,
    env = _useContext3.env;
  var isUsingGlm3 = (glm === null || glm === void 0 ? void 0 : glm.version) === 3;
  var _ref2 = glm !== null && glm !== void 0 ? glm : {},
    glmFullOwnerDetails = _ref2.fullOwnerDetails;
  var actionButtonsBar = (_StepDefinitions$find = StepDefinitions.find(function (step) {
    return step.id === _steps.Steps.STEP_3;
  })) === null || _StepDefinitions$find === void 0 ? void 0 : _StepDefinitions$find.actionButtonsBar;
  var _useMatchBreakpoint = (0, _useMatchBreakpoint2.useMatchBreakpoint)(_breakpoints.MOBILE_MODE_BREAK_POINT_IN_PX),
    isMobileMode = _useMatchBreakpoint.match;
  var customContainerType = (0, _useCustomContainerType.useCustomContainerType)(isMobileMode, actionButtonsBar === null || actionButtonsBar === void 0 || (_actionButtonsBar$sec = actionButtonsBar.secondary) === null || _actionButtonsBar$sec === void 0 ? void 0 : _actionButtonsBar$sec.containerType);
  var formId = (0, _react.useId)();
  var formContext = (0, _reactHookForm.useFormContext)();
  var owner = formContext.getValues('owner');
  var externalId = formContext.getValues('externalId');
  var hasMemberNumber = formContext.getValues('hasMemberNumber');
  var memberNumber = formContext.getValues('memberNumber');
  var memberNumberPassThroughDefault = basicOwnerDetails === null || basicOwnerDetails === void 0 || (_basicOwnerDetails$ow = basicOwnerDetails.ownerMemberNumberInput) === null || _basicOwnerDetails$ow === void 0 ? void 0 : _basicOwnerDetails$ow.passThroughDefault;
  var _authorisedPersonDisp = authorisedPersonDisplaySettings.authorisedPersonPanelToggleRadios,
    isAuthorisedPersonValidation = _authorisedPersonDisp.validation,
    authorisedPersonPanelToggleRadiosWithoutValidation = _objectWithoutProperties(_authorisedPersonDisp, _excluded),
    authorisedPersonDisplaySettingsWithoutValidation = _objectWithoutProperties(authorisedPersonDisplaySettings, _excluded2);
  var authorisedPersonDisplaySettingsModified = _objectSpread(_objectSpread({}, authorisedPersonDisplaySettingsWithoutValidation), {}, {
    authorisedPersonPanelToggleRadios: authorisedPersonPanelToggleRadiosWithoutValidation
  });
  var _regularVetDisplaySet = regularVetDisplaySettings.regularVetPanelToggleRadios,
    isRegularVetValidation = _regularVetDisplaySet.validation,
    regularVetPanelToggleRadiosWithoutValidation = _objectWithoutProperties(_regularVetDisplaySet, _excluded3),
    regularVetDisplaySettingsWithoutValidation = _objectWithoutProperties(regularVetDisplaySettings, _excluded4);
  var regularVetDisplaySettingsModified = _objectSpread(_objectSpread({}, regularVetDisplaySettingsWithoutValidation), {}, {
    regularVetPanelToggleRadios: regularVetPanelToggleRadiosWithoutValidation
  });
  var fullOwnerDetailsFormContext = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, formContext), formContext.register('owner.hasAuthorisePerson', {
    validate: function validate(value) {
      if (isAuthorisedPersonValidation && isAuthorisedPersonValidation.required) {
        if (value !== null) {
          return true;
        }
        return isAuthorisedPersonValidation.required;
      }
      return value;
    },
    setValueAs: function setValueAs(value) {
      if (value !== undefined && value !== null) {
        return _form.formHelpers.mapRadioValueToBoolean(value);
      }
      return value;
    }
  })), formContext.register('hasRegularVet', {
    validate: function validate(value) {
      if (isRegularVetValidation && isRegularVetValidation.required) {
        if (value !== null) {
          return true;
        }
        return isRegularVetValidation.required;
      }
      return value;
    },
    setValueAs: function setValueAs(value) {
      if (value !== undefined && value !== null) {
        return _form.formHelpers.mapRadioValueToBoolean(value);
      }
      return value;
    }
  })), formContext.register('owner.isEmailCommunicaton', {
    setValueAs: function setValueAs(value) {
      return _form.formHelpers.mapRadioValueToBoolean(value);
    }
  }));
  var _useSelector = (0, _reactRedux.useSelector)(_selectors.mediasSelector),
    medias = _useSelector.value;
  var _useSelector2 = (0, _reactRedux.useSelector)(_selectors.titlesSelector),
    titles = _useSelector2.value;
  var _useSelector3 = (0, _reactRedux.useSelector)(_selectors.vetsSelector),
    vets = _useSelector3.value;
  var vetSearchable = (0, _useLocalSearch.useLocalSearch)(vets, 'description', function (result) {
    return {
      vetNumber: result.serviceProviderNumber,
      vet: result.description
    };
  });
  var mediaOptions = (0, _react.useMemo)(function () {
    return medias.map(function (media) {
      return {
        label: media.description,
        value: media.mediaCode
      };
    });
  }, [medias]);
  var titleOptions = (0, _react.useMemo)(function () {
    return titles.map(function (title) {
      return title.description;
    });
  }, [titles]);
  var titleName = formContext.watch('owner.titleName');
  var handleSearchVet = function handleSearchVet(keyword) {
    vetSearchable.setSearchKeyword(keyword);
  };
  var handleTitleChange = function handleTitleChange(event) {
    var title = event.target.value;
    formContext.setValue('owner.titleCode', title.toUpperCase());
  };
  var handleAddressChange = function handleAddressChange(addressInfo) {
    formContext.setValue('owner.dpid', addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.dpid);
    formContext.setValue('owner.barcode', addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.barcode);
    formContext.setValue('owner.state', addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.state);
    formContext.setValue('owner.suburb', addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.suburb);
    formContext.setValue('owner.postcode', addressInfo.postcode);
    formContext.setValue('owner.streetAddress', addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.streetAddress);
    if (addressInfo !== null && addressInfo !== void 0 && addressInfo.streetAddress) {
      formContext.setFocus('owner.address');
      formContext.setValue('owner.address', addressInfo.streetAddress);
      if (addressInfo !== null && addressInfo !== void 0 && addressInfo.suburb && addressInfo !== null && addressInfo !== void 0 && addressInfo.state && addressInfo !== null && addressInfo !== void 0 && addressInfo.postcode) {
        formContext.setValue('owner.fullAddress', "".concat(addressInfo.streetAddress, ", ").concat(addressInfo.suburb, ", ").concat(addressInfo.state, ", ").concat(addressInfo.postcode));
      }
    } else {
      formContext.setValue('owner.address', '');
      formContext.setValue('owner.fullAddress', '');
    }
  };
  var handleChangeCoverOptions = function handleChangeCoverOptions() {
    navigationController("/".concat(StepDefinitions.find(function (step) {
      return step.id === _steps.StepIndex.coverOptions;
    }).url));
  };
  var handleOpenEmailPanel = function handleOpenEmailPanel() {
    openEmailPanel();
  };
  var handleBirthdateEdit = function handleBirthdateEdit() {
    navigationController("/".concat(StepDefinitions.find(function (step) {
      return step.id === _steps.StepIndex.youAndYourPets;
    }).url));
  };
  var authorisedPersonDetails = {
    hasAuthorisePerson: _form.formHelpers.mapRadioValueToBoolean(owner === null || owner === void 0 ? void 0 : owner.hasAuthorisePerson),
    firstName: (_owner$authorisedMemb = owner === null || owner === void 0 ? void 0 : owner.authorisedMemberFirstName) !== null && _owner$authorisedMemb !== void 0 ? _owner$authorisedMemb : '',
    lastName: (_owner$authorisedMemb2 = owner === null || owner === void 0 ? void 0 : owner.authorisedMemberSurname) !== null && _owner$authorisedMemb2 !== void 0 ? _owner$authorisedMemb2 : '',
    birthdate: (0, _helpers.IsValidDate)(owner === null || owner === void 0 ? void 0 : owner.authorisedMemberDob) ? (0, _helpers.DateToShortIsoString)(owner === null || owner === void 0 ? void 0 : owner.authorisedMemberDob) : ''
  };
  var regularVetDetails = {
    hasRegularVet: _form.formHelpers.mapRadioValueToBoolean(formContext.getValues('hasRegularVet')),
    vet: formContext.getValues('regularVet'),
    vetNumber: formContext.getValues('regularVetCode')
  };
  var getActionButtonsProps = function getActionButtonsProps(actionbuttonId) {
    switch (actionbuttonId) {
      case _constants.SUBMIT_BUTTON:
        return {
          onClick: onFormSubmit
        };
      case _constants.CANCEL_BUTTON:
        return {
          onClick: handleChangeCoverOptions
        };
      case _constants.SEND_EMAIL_BUTTON:
        return {
          onClick: handleOpenEmailPanel
        };
      default:
        return null;
    }
  };
  (0, _react.useEffect)(function () {
    if (isUsingGlm3) {
      if ((0, _helpers.DateToShortIsoString)(owner.dateofBirth) === (0, _helpers.DateToShortIsoString)(glmFullOwnerDetails.ownerBirthdateInput.defaultValue)) {
        formContext.setValue('owner.dateofBirth', null);
      }
    }
    if (memberNumber === memberNumberPassThroughDefault) {
      formContext.setValue('memberNumber', null);
    }
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "fullOwnerDetails"
  }, /*#__PURE__*/_react["default"].createElement(_QuoteHeading.QuoteToolHeading, {
    headingText: "Your details",
    showMandatoryText: showMandatoryText,
    mandatoryText: mandatoryText
  }), /*#__PURE__*/_react["default"].createElement("fieldset", null, /*#__PURE__*/_react["default"].createElement(_components.TitlesDropdown, _extends({
    showSpinner: isDataPending || !titleOptions || (titleOptions === null || titleOptions === void 0 ? void 0 : titleOptions.length) === 0,
    fieldFormContext: formContext,
    name: "owner.titleName",
    autoComplete: "honorific-prefix",
    options: titleOptions
  }, ownerTitleInput, {
    value: titleName !== null && titleName !== void 0 ? titleName : '',
    customChangeHandler: handleTitleChange
  })), /*#__PURE__*/_react["default"].createElement(_components.InputText, _extends({
    showSpinner: isDataPending,
    fieldFormContext: fullOwnerDetailsFormContext,
    name: "owner.firstName",
    autoComplete: "given-name"
  }, ownerFirstNameInput, {
    defaultValue: owner.firstName,
    autoCapitalize: "words",
    maxLength: 30
  })), /*#__PURE__*/_react["default"].createElement(_components.InputText, _extends({
    showSpinner: isDataPending,
    fieldFormContext: fullOwnerDetailsFormContext,
    name: "owner.surname",
    autoComplete: "family-name"
  }, ownerLastNameInput, {
    defaultValue: owner.surname,
    autoCapitalize: "words",
    maxLength: 30
  })), isUsingGlm3 ? /*#__PURE__*/_react["default"].createElement(_components.OwnerBirthdate, _extends({
    fieldFormContext: formContext,
    name: "owner.dateofBirth",
    autoComplete: "bday",
    defaultValue: (0, _helpers.IsValidDate)(owner.dateofBirth) ? (0, _helpers.DateToShortIsoString)(owner.dateofBirth) : ''
  }, ownerBirthdateInput)) : /*#__PURE__*/_react["default"].createElement(_components.EditableReadonlyField, {
    showSpinner: isDataPending,
    fieldFormContext: formContext,
    onEditModeChange: handleBirthdateEdit,
    fieldElement: /*#__PURE__*/_react["default"].createElement(_components.OwnerBirthdate, _extends({
      fieldFormContext: formContext,
      name: "owner.dateofBirth",
      autoComplete: "bday",
      defaultValue: (0, _helpers.IsValidDate)(owner.dateofBirth) ? (0, _helpers.DateToShortIsoString)(owner.dateofBirth) : ''
    }, ownerBirthdateInput, {
      readOnly: true
    }))
  }), /*#__PURE__*/_react["default"].createElement(_components.InputText, _extends({
    showSpinner: isDataPending,
    fieldFormContext: formContext,
    name: "owner.telephoneMobile",
    autoComplete: "tel",
    inputType: "tel",
    defaultValue: owner.telephoneMobile,
    maxLength: 10
  }, ownerMobileInput)), /*#__PURE__*/_react["default"].createElement(_components.InputText, _extends({
    showSpinner: isDataPending,
    fieldFormContext: formContext,
    name: "owner.email",
    autoComplete: "email",
    inputType: "email",
    defaultValue: owner.email
  }, ownerEmailInput)), ownerVelocityMembershipNumber && formContext.getValues('promotionCode') === 'VELOCITYPET' && /*#__PURE__*/_react["default"].createElement(_components.InputText, _extends({
    fieldFormContext: formContext,
    name: "externalId",
    defaultValue: externalId
  }, ownerVelocityMembershipNumber)), /*#__PURE__*/_react["default"].createElement(_AddressDetails.AddressDetails, {
    formId: formId,
    name: "owner.fullAddress",
    onAddressChange: handleAddressChange,
    autoCompleteProps: ownerAddressAutoCompleteInput,
    actionButtonsBarSetting: manualAddressEntryPanel === null || manualAddressEntryPanel === void 0 || (_manualAddressEntryPa = manualAddressEntryPanel.actionButtonsBars) === null || _manualAddressEntryPa === void 0 ? void 0 : _manualAddressEntryPa.primary
  }), hasMemberNumber && /*#__PURE__*/_react["default"].createElement(_components.InputText, _extends({
    fieldFormContext: formContext,
    name: "memberNumber",
    autoComplete: "off",
    defaultValue: memberNumber
  }, ownerMemberNumberInput)), /*#__PURE__*/_react["default"].createElement(_PreloadWrapper.PreloadWrapper, {
    isLoading: isDataPending
  }, /*#__PURE__*/_react["default"].createElement(_widgets.AuthorisedPersonForm, {
    formId: formId,
    formContext: fullOwnerDetailsFormContext,
    authorisedPersonDetails: authorisedPersonDetails,
    authorisedPersonDisplaySettings: authorisedPersonDisplaySettingsModified
  })), /*#__PURE__*/_react["default"].createElement(_PreloadWrapper.PreloadWrapper, {
    isLoading: isDataPending
  }, /*#__PURE__*/_react["default"].createElement(_widgets.RegularVet, {
    showSpinner: isDataPending,
    formId: formId,
    formContext: fullOwnerDetailsFormContext,
    onSearch: handleSearchVet,
    searchResults: vetSearchable.searchResults,
    regularVetDetails: regularVetDetails,
    regularVetDisplaySettings: regularVetDisplaySettingsModified
  })), /*#__PURE__*/_react["default"].createElement(_PreloadWrapper.PreloadWrapper, {
    isLoading: isDataPending
  }, /*#__PURE__*/_react["default"].createElement(_components.StyledRadios, _extends({
    fieldFormContext: fullOwnerDetailsFormContext,
    groupName: "owner.isEmailCommunicaton",
    name: "owner.isEmailCommunicaton",
    value: _form.formHelpers.mapBooleanToRadioValue(owner.isEmailCommunicaton)
  }, ownerEmailCommsRadios))), showCustomerSource && /*#__PURE__*/_react["default"].createElement(_components.Dropdown, _extends({
    fieldFormContext: formContext,
    name: "selectedMediaListCode"
  }, ownerMarketingFeedChannel, {
    options: mediaOptions,
    value: (_formContext$getValue = formContext.getValues('selectedMediaListCode')) !== null && _formContext$getValue !== void 0 ? _formContext$getValue : ''
  }))), /*#__PURE__*/_react["default"].createElement(_components.ActionButtonsBar, _extends({}, actionButtonsBar === null || actionButtonsBar === void 0 ? void 0 : actionButtonsBar.primary, {
    actionItems: actionButtonsBar === null || actionButtonsBar === void 0 || (_actionButtonsBar$pri = actionButtonsBar.primary) === null || _actionButtonsBar$pri === void 0 ? void 0 : _actionButtonsBar$pri.actionItems.map(function (item) {
      return _objectSpread(_objectSpread({}, item), getActionButtonsProps(item === null || item === void 0 ? void 0 : item.id));
    })
  })), /*#__PURE__*/_react["default"].createElement(_components.ActionButtonsBar, {
    containerType: customContainerType,
    actionItems: actionButtonsBar === null || actionButtonsBar === void 0 || (_actionButtonsBar$sec2 = actionButtonsBar.secondary) === null || _actionButtonsBar$sec2 === void 0 ? void 0 : _actionButtonsBar$sec2.actionItems.map(function (item) {
      return _objectSpread(_objectSpread({}, item), getActionButtonsProps(item === null || item === void 0 ? void 0 : item.id));
    })
  }), privacyCollectionNotice && /*#__PURE__*/_react["default"].createElement("div", {
    className: "disclaimer"
  }, privacyCollectionNotice(contactStatementLogo ? "".concat((0, _environment.GetCDNBaseURL)({
    env: env
  }), "/").concat(brandKey, "/").concat(contactStatementLogo) : null)));
};